export let AgMemberLayoutJSON = [
  {
    name: "Personal Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1624697220665-col-1",
                elementid: "1624697288049",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624697220665-columns",
            elementid: "1624697220665-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624697220665-col-2",
                elementid: "1624697291931",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1624697220665-columns",
            elementid: "1624697220665-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1624697220665",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624697264531-col-1",
                elementid: "1624697533254",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1624697264531-columns",
            elementid: "1624697264531-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624697264531-col-2",
                elementid: "1624697545242",
                elementtype: "date",
              },
            ],
            colpos: 2,
            parentid: "1624697264531-columns",
            elementid: "1624697264531-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1624697264531",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624703923683-col-1",
                elementid: "1624703938549",
                elementtype: "email",
              },
            ],
            colpos: 1,
            parentid: "1624703923683-columns",
            elementid: "1624703923683-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624703923683-col-2",
                elementid: "1624703942272",
                elementtype: "email",
              },
            ],
            colpos: 2,
            parentid: "1624703923683-columns",
            elementid: "1624703923683-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1624703923683",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624703997729-col-1",
                elementid: "1625058231955",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624703997729-columns",
            elementid: "1624703997729-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624703997729-col-2",
                elementid: "1625734264498",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1624703997729-columns",
            elementid: "1624703997729-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1624703997729",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1625734253225-col-1",
                elementid: "1624704019883",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1625734253225-columns",
            elementid: "1625734253225-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1625734253225-col-2",
                elementid: "1625734325899",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1625734253225-columns",
            elementid: "1625734253225-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1625734253225",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1625734404457-col-1",
                elementid: "1625734415860",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1625734404457-columns",
            elementid: "1625734404457-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1625734404457-col-2",
                elementid: "1625734418506",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1625734404457-columns",
            elementid: "1625734404457-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1625734404457",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624704391892-col-1",
                elementid: "1624704400175",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624704391892-columns",
            elementid: "1624704391892-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624704391892-col-2",
                elementid: "1625733914550",
                elementtype: "date",
              },
            ],
            colpos: 2,
            parentid: "1624704391892-columns",
            elementid: "1624704391892-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1624704391892",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624704091813-col-1",
                elementid: "1624704105599",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1624704091813-columns",
            elementid: "1624704091813-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624704091813-col-2",
                elementid: "1624704111143",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624704091813-columns",
            elementid: "1624704091813-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623751745518-form",
        elementid: "1624704091813",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1623751745518",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "Hospital Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1624704914838-col-1",
                elementid: "1624704941877",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1624704914838-columns",
            elementid: "1624704914838-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624704914838-col-2",
                elementid: "1624704946038",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1624704914838-columns",
            elementid: "1624704914838-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624702044808-form",
        elementid: "1624704914838",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624704929949-col-1",
                elementid: "1624704991448",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624704929949-columns",
            elementid: "1624704929949-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624704929949-col-2",
                elementid: "1624704996494",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1624704929949-columns",
            elementid: "1624704929949-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624702044808-form",
        elementid: "1624704929949",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1626173324188-col-1",
                elementid: "1624705014487",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1626173324188-columns",
            elementid: "1626173324188-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1626173324188-col-2",
                elementid: "1626173406294",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1626173324188-columns",
            elementid: "1626173324188-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624702044808-form",
        elementid: "1626173324188",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1626173358255-col-1",
                elementid: "1626173413159",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1626173358255-columns",
            elementid: "1626173358255-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1626173358255-col-2",
                elementid: "1626173461113",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1626173358255-columns",
            elementid: "1626173358255-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624702044808-form",
        elementid: "1626173358255",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624704935471-col-1",
                elementid: "1624705005678",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1624704935471-columns",
            elementid: "1624704935471-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [],
            colpos: 2,
            parentid: "1624704935471-columns",
            elementid: "1624704935471-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624702044808-form",
        elementid: "1624704935471",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1624702044808",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "IMA Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1624705231112-col-1",
                elementid: "1624705250484",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624705231112-columns",
            elementid: "1624705231112-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624705231112-col-2",
                elementid: "1624705254690",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1624705231112-columns",
            elementid: "1624705231112-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624705205221-form",
        elementid: "1624705231112",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624705234852-col-1",
                elementid: "1626085207511",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1624705234852-columns",
            elementid: "1624705234852-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624705234852-col-2",
                elementid: "1626085252987",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1624705234852-columns",
            elementid: "1624705234852-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624705205221-form",
        elementid: "1624705234852",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1624705205221",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
